import { useTranslation } from 'react-i18next';
import { RhfTextField, type RhfTextFieldProps } from './shared/RhfTextField';

export type RegistrationIdFieldProps = Omit<RhfTextFieldProps, 'label'> & {
  label?: string;
};

/**
 * `RegistrationIdField` — RHF-bound text input for
 * `Org.legal.registrationId` (الرقم الموحد — unified establishment
 * number, 10 digits starting with 7).
 *
 * - `inputMode='numeric'` opens the digit pad on mobile — unified
 *   numbers are 10-digit numeric in Saudi Arabia (first digit 7).
 * - We deliberately do **not** force numeric here, just hint it —
 *   the platform also accepts non-SA carriers in the long-term
 *   roadmap, and stripping letters would be hostile to those
 *   organisations.
 */
export function RegistrationIdField(props: RegistrationIdFieldProps) {
  const { t } = useTranslation('m-organization');
  return (
    <RhfTextField
      {...props}
      label={props.label ?? t('form.cr_number.title')}
      placeholder={props.placeholder ?? t('form.cr_number.placeholder')}
      helper={props.helper ?? t('form.cr_number.helper')}
      inputMode={props.inputMode ?? 'numeric'}
    />
  );
}
